import awsdk from 'awsdk';

// VISIT_EXPIRED
// CONSUMER_DISCONNECT_POST_THRESHOLD
// CONSUMER_DISCONNECT_PRE_THRESHOLD
// CONSUMER_FORCED_DISCONNECT
// CONSUMER_CANCEL
// CONSUMER_IVR_AUTH_FAILED
// CONSUMER_END
// INITIATOR_LOGOUT_PRE_VISIT
// INITIATOR_LOGOUT_AFTER_START
// PROVIDER_END
// PROVIDER_DECLINE
// PROVIDER_DECLINE_AND_TRANSFER
// PROVIDER_BAIL
// PROVIDER_DISCONNECT
// PROVIDER_RESPONSE_TIMEOUT
// PROVIDER_LOGOUT
// PROVIDER_IVR_AUTH_FAILED
// ASSISTANT_DECLINE
// ASSISTANT_DECLINE_AND_TRANSFER
// WAITING_ROOM_EXPIRED
// ASYNC_COST_CALC_EXCEPTION
// CONSUMER_TRANSFER
// VIDYO_FAILED

export const EndReason = awsdk.AWSDKEndReason;
export type EndReason = typeof EndReason;
